import React from "react";
import { Popover, ConfigProvider } from "antd";

import { Colors } from "../../config";

const DefaultPopover = (props) => {
  const content = props?.content;
  return (
    <ConfigProvider
      theme={{
        token: {
          colorBgElevated: Colors.main,
          colorText: "white",
          controlItemBgHover: Colors.LightSecondary,
        },
      }}
    >
      <Popover
        placement={props?.placement || "leftTop"}
        title={props?.title ?? null}
        content={content}
        arrow={{ pointAtCenter: true }}
        trigger={props?.trigger ?? "click"}
      >
        {props?.children}
      </Popover>
    </ConfigProvider>
  );
};

export default DefaultPopover;
